// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: common/notifications.proto

/* eslint-disable */
import type { Experience } from "../experience/experience";
import type { Bot, NotificationTopic } from "./common";
import type { User } from "./users";

export interface Notification {
  id: string;
  subject: string;
  content: string;
  primaryImage: string;
  secondaryImage: string;
  restPath: string;
  createdAt: string | undefined;
  bot?: Bot | undefined;
  experience?: Experience | undefined;
  notificationTopic: NotificationTopic | undefined;
  link?: string | undefined;
  iframeLink?: string | undefined;
  senderUser?: User | undefined;
}

export interface GoFetchNotifications {
  entityId: string;
  entityType: GoFetchNotifications_NotifyingEntityType;
  /** If true, the client should refetch the badge for this entity. */
  mayIncrementBadgeCount: boolean;
  /** A unique identifier that can be used to fetch the associated notification from the backend. */
  notificationId: string;
}

export const GoFetchNotifications_NotifyingEntityType = {
  UNKNOWN: "UNKNOWN",
  GENERIC: "GENERIC",
  EXPERIENCE: "EXPERIENCE",
  COMPANY: "COMPANY",
  COMPANY_TEAM: "COMPANY_TEAM",
  ACCESS_PASS: "ACCESS_PASS",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type GoFetchNotifications_NotifyingEntityType =
  typeof GoFetchNotifications_NotifyingEntityType[keyof typeof GoFetchNotifications_NotifyingEntityType];

export namespace GoFetchNotifications_NotifyingEntityType {
  export type UNKNOWN = typeof GoFetchNotifications_NotifyingEntityType.UNKNOWN;
  export type GENERIC = typeof GoFetchNotifications_NotifyingEntityType.GENERIC;
  export type EXPERIENCE = typeof GoFetchNotifications_NotifyingEntityType.EXPERIENCE;
  export type COMPANY = typeof GoFetchNotifications_NotifyingEntityType.COMPANY;
  export type COMPANY_TEAM = typeof GoFetchNotifications_NotifyingEntityType.COMPANY_TEAM;
  export type ACCESS_PASS = typeof GoFetchNotifications_NotifyingEntityType.ACCESS_PASS;
  export type UNRECOGNIZED = typeof GoFetchNotifications_NotifyingEntityType.UNRECOGNIZED;
}

export interface SendNotificationToUserRequest {
  userId: string;
  notification: Notification | undefined;
  userIds: string[];
}

export interface SendNotificationToUserResponse {
  sent: boolean;
}

export interface NotificationService {
  SendNotificationToUser(request: SendNotificationToUserRequest): Promise<SendNotificationToUserResponse>;
}
